'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _checks = require('./checks.component');

var _checks2 = _interopRequireDefault(_checks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checksModule = _angular2.default.module('app.containers.checks', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('checks', {
    url: '/checks',
    template: '<checks></checks>'
  });
}).component('checks', _checks2.default);

exports.default = checksModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/checks/checks.js
 **/